import React, { useContext } from 'react';

import { OfferContext } from '../../../../components/Offer/context';

import { Trustbox } from '../Trustbox';
import styled from '@emotion/styled';
import { ResponsiveImage } from '../../../../components/ResponsiveImage';

export const Logo: React.FC = () => {
    const { logo, logoPadding } = useContext(OfferContext);

    if (!logo) return null;

    return (
        <Wrapper>
            <ResponsiveImage
                image={logo}
                className="Offer__logo"
                style={{
                    objectFit: true,
                    padding: logoPadding ? '20px 40px' : '',
                }}
            />
            <Trustbox />
        </Wrapper>
    );
};

const Wrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;

    img {
        display: block;
        max-width: 100%;
        height: auto;
        max-height: 100%;
    }
`;
